import { useEffect } from 'react';

export const SCROLL_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right'
};

const mapScrollDirectionToFn = ({ ref, gap = 80 }) => ({
  [SCROLL_DIRECTIONS.UP]: () => {
    ref.current.scrollTop -= gap;
  },
  [SCROLL_DIRECTIONS.DOWN]: () => (ref.current.scrollTop += gap),
  [SCROLL_DIRECTIONS.LEFT]: () => (ref.current.scrollLeft -= gap),
  [SCROLL_DIRECTIONS.RIGHT]: () => (ref.current.scrollLeft += gap)
});

const useScroll = ref => {
  let autoScrollInterval = null;

  const scroll = ({ direction, gap }) => {
    const scrollFn = mapScrollDirectionToFn({ ref, gap })[direction];
    scrollFn();
  };
  const startAutoScroll = ({ direction, gap }) => {
    autoScrollInterval = setInterval(() => scroll({ direction, gap }), 100);
  };
  const stopAutoScroll = () => {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
      autoScrollInterval = null;
    }
  };

  useEffect(() => {
    return () => {
      if (autoScrollInterval) clearInterval(autoScrollInterval);
    };
  });

  return {
    scroll,
    startAutoScroll,
    stopAutoScroll
  };
};

export default useScroll;
